import { createSlice } from '@reduxjs/toolkit';

const answerSlice = createSlice({
    name: 'answer',
    initialState: [],
    reducers: {
        saveAnswer: (state, action) => {
            const { questionId, selectedOption } = action.payload;
            const existingAnswer = state.find(answer => answer.questionId === questionId);

            if (existingAnswer) {
                // Update existing answer if the question has already been answered
                existingAnswer.selectedOption = selectedOption;
            } else {
                // Add a new answer if the question is answered for the first time
                state.push({ questionId, selectedOption });
            }
        },
        clearAnswers: (state) => {
            return [];
        },
    },
});

export const { saveAnswer, clearAnswers } = answerSlice.actions;

export default answerSlice.reducer;
